export default {
    
    // Brand and tagline
    "sri_astro_veda": "ಸೂರ್ಯ ಮೀಡಿಯಾ",
    "footer_tagline": "ಜ್ಯೋತಿಷ್ಯ ಮತ್ತು ವಾಸ್ತು. ಆಧುನಿಕ, ವೈಯಕ್ತಿಕ, ವಿಶ್ವಾಸಾರ್ಹ.",

    // Navigation
    "navigation": "ನ್ಯಾವಿಗೇಷನ್",
    "home": "ಮನೆ",
    "about": "ನಮ್ಮ ಬಗ್ಗೆ",
    "contact": "ಸಂಪರ್ಕ",
    "get_reading": "ಓದುವಿಕೆ ಪಡೆಯಿರಿ",

    // Core Services
    "core_services_footer": "ಮುಖ್ಯ ಸೇವೆಗಳು",
    "birth_chart_footer": "ಜನ್ಮ ಪತ್ರಿ",
    "match_kundli_footer": "ಕುಂಡಲಿ ಹೊಂದಾಣಿಕೆ",
    "ascendant_footer": "ಲಗ್ನ",
    "dasha_analysis_footer": "ದಶಾ ವಿಶ್ಲೇಷಣೆ",
    "nakshatra_footer": "ನಕ್ಷತ್ರ",
    "numerology_footer": "ಅಂಕಶಾಸ್ತ್ರ",

    // Predictions
    "predictions_footer": "ಭವಿಷ್ಯವಾಣಿಗಳು",
    "life_predictions_footer": "ಜೀವನ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "2025_report_footer": "2025 ವರದಿ",
    "daily_horoscope_footer": "ದೈನಂದಿನ ರಾಶಿಫಲ",
    "love_report_footer": "ಪ್ರೇಮ ವರದಿ",
    "career_report_footer": "ವೃತ್ತಿ ವರದಿ",
    "health_report_footer": "ಆರೋಗ್ಯ ವರದಿ",

    // Remedies
    "remedies_footer": "ಪರಿಹಾರಗಳು",
    "lal_kitab_footer": "ಲಾಲ್ ಕಿತಾಬ್",
    "mangal_dosha_footer": "ಮಂಗಳ ದೋಷ",
    "kalsarp_dosh_footer": "ಕಾಲಸರ್ಪ ದೋಷ",
    "sade_sati_footer": "ಸಾಢೇಸಾತಿ",
    "ask_question_footer": "ಪ್ರಶ್ನೆ ಕೇಳಿ",
    "gemstones_footer": "ರತ್ನಗಳು",

    // Support
    "support": "ಬೆಂಬಲ",
    "whatsapp_support": "ವಾಟ್ಸ್ಆಪ್ ಬೆಂಬಲ",
    "available_24_7": "ಚಾಟ್ ಬೆಂಬಲ",

    // Footer bottom
    "all_rights_reserved": "ಎಲ್ಲಾ ಹಕ್ಕುಗಳು ಸಂರಕ್ಷಿತ",
    "made_with": "ಪ್ರೀತಿಯಿಂದ ತಯಾರಿಸಲಾಗಿದೆ",
    "in_india": "ಭಾರತದಲ್ಲಿ",
    "privacy_policy": "ಗೌಪ್ಯತಾ ನೀತಿ",
    "terms_of_service": "ಸೇವಾ ನಿಯಮಗಳು",
    "disclaimer": "ಹಕ್ಕುತ್ಯಾಗ",
    "cancellation_policy": "ರದ್ದುಗೊಳಿಸುವ ನೀತಿ",
    "shipping_policy": "ಶಿಪ್ಪಿಂಗ್ ನೀತಿ"
}
